import { getStorage, ref, getDownloadURL } from "firebase/storage";

// Create a reference with an initial file path and name
const storage = getStorage();

export async function GetDicomUrls(path:string, series:number, start:number, end:number): Promise<string[]> {
    //path: Explanation/Head/...(データパス) dcm_num: 601(dicomの頭番号) start:1(dicomの開始番号) end: 25(dicomの終了番号)
    const pathname = path;
    var images = []
    for (let i = start - 1; i < end; i++) {
        let fileName = series + '_' + String(i + 1) + '.dcm';
        images.push(pathname + '/' + fileName);
    }

    const DicomUrls = await Promise.all(images.map((element) => {
        const DicomUrl = getDownloadURL(ref(storage, element))
            .then((url) => {
            return 'dicomweb:' + url;
        })
        .catch((error) => {
            console.log(error);
            return 'dicomweb:'
          });
        return DicomUrl;
    }))
    return DicomUrls;
};


export async function getKeyImageUrl(path:string): Promise<string> {
    //path: Explanation/Head/...(データパス) dcm_num: 601(dicomの頭番号) start:1(dicomの開始番号) end: 25(dicomの終了番号)
    
    const KeyImageUrl = await getDownloadURL(ref(storage, path))
        .then((url) => {
        return url;
    })
    .catch((error) => {
        console.log(error);
        return ''
        });
    return KeyImageUrl;
};